import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  PostMagazineCenterFeatureContainer,
  PostMagazineLeftWrapper,
  PostMagazineLogoWrapper,
} from "scmp-app/components/header/styles";

export const getPostMagazineLayout = ({ features }: HeaderLayoutProps): HeaderLayoutContent => ({
  center: (
    <>
      <PostMagazineCenterFeatureContainer>
        {features.postMagazineOnelineMenu({ showIn: "desktopUp" })}
        <PostMagazineLogoWrapper>
          {features.postMagazineLogoLink({
            showIn: "mobileAndTablet",
          })}
          {features.postMagazineLogoTextLink({
            showIn: "mobileAndTablet",
          })}
        </PostMagazineLogoWrapper>
      </PostMagazineCenterFeatureContainer>
    </>
  ),
  left: (
    <>
      {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
      <PostMagazineLeftWrapper>
        <PostMagazineLogoWrapper>
          {features.postMagazineLogoLink({
            showIn: "desktopUp",
          })}
          {features.postMagazineLogoTextLink({
            showIn: "desktopUp",
          })}
        </PostMagazineLogoWrapper>
        {features.search({ showDesktopDivider: true, showIn: "mobileUp" })}
      </PostMagazineLeftWrapper>
    </>
  ),
  right: (
    <>
      {features.subscription({
        fallback: features.myNews(),
        showIn: "desktopUp",
        variant: "dark",
      })}
      {features.myNews({
        showIn: "mobileAndTablet",
        showWhenLoggedIn: true,
      })}
      {features.dashboard({
        showIn: "mobileUp",
        variant: "postmag",
      })}
    </>
  ),
});
